import { Fragment, useEffect, useState } from "react";
import "./productlist.css";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { getAdminProducts, deleteProduct } from "../../actions/productActions";
import {
  clearError,
  clearProductDeleted,
} from "../../slices/singleProductSlice";
import Loader from "../layouts/Loader";
import { toast } from "react-toastify";
import Sidebar from "./Sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown, Button } from "react-bootstrap";
import Pagination from "react-js-pagination";
import {
  faCartShopping,
  faFilter,
  faPencil,
  faSearch,
  faDashboard,
  faList,
  faShoppingBag,
  faSort,
  faUserPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import Drawer from "@mui/material/Drawer";
import { Modal, Box, Typography } from "@mui/material";
import MetaData from "../layouts/MetaData";
import XLSX from "xlsx-js-style";

// Currently this is ok i completed all need ref means see below code

export default function ProductList() {
  const location = useLocation();
  const {
    products = [],
    loading = true,
    resPerPage,
    error,
    filteredProductsCount,
  } = useSelector((state) => state.productsState);
  const { isProductDeleted, error: productError } = useSelector(
    (state) => state.productState,
  );
  const [clocreProductId, setclocreProductId] = useState("");
  const [searchKeyword] = useState(""); // this is submitted one
  const [filterStatus, setFilterStatus] = useState(
    () => location.state?.filterStatus || "",
  );
  const [filterVisible, setFilterVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    () => location.state?.currentPage || 1,
  );
  // const [limit, setLimit] = useState(10);

  const dispatch = useDispatch();
  const deleteHandler = (e, id) => {
    e.target.disabled = true;
    dispatch(deleteProduct(id));
  };

  const setCurrentPageNo = (pageNo) => {
    setCurrentPage(pageNo);
  };

  function debounce(func, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), delay);
    };
  }
  // useEffect(() => {
  //   const debouncedSearch = debounce(() => {
  //     dispatch(getAdminProducts(clocreProductId, filterStatus, 1)); // always reset to 1
  //     setCurrentPage(1);
  //   }, 500); // 500ms debounce

  //   debouncedSearch();

  //   // Cleanup on unmount
  //   return () => {
  //     debouncedSearch.cancel && debouncedSearch.cancel();
  //   };
  // }, [clocreProductId, filterStatus, dispatch]);

  const handleFilterChange = (status) => {
    setFilterStatus(status);
    setCurrentPage(1);
  };

  const filterLabel = {
    approved: "Approved",
    pending: "Pending",
    rejected: "Rejected",
    deactivated: "Deactivated",
    "": "All",
  }[filterStatus];

  // useEffect(() => {
  //   if (error || productError) {
  //     toast(error || productError, {
  //       type: "error",
  //       onOpen: () => {
  //         dispatch(clearError());
  //       },
  //     });
  //     return;
  //   }

  //   if (isProductDeleted) {
  //     toast("Product Deleted Succesfully!", {
  //       type: "success",
  //       onOpen: () => dispatch(clearProductDeleted()),
  //     });
  //     return;
  //   }

  //   dispatch(getAdminProducts(searchKeyword, filterStatus, currentPage));
  // }, [
  //   dispatch,
  //   error,
  //   productError,
  //   isProductDeleted,
  //   searchKeyword,
  //   filterStatus,
  //   currentPage,
  // ]);

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(getAdminProducts(clocreProductId, filterStatus, currentPage));
    }, 500);

    return () => clearTimeout(timer);
  }, [dispatch, clocreProductId, filterStatus, currentPage]);

  useEffect(() => {
    if (error || productError) {
      toast(error || productError, {
        type: "error",
        onOpen: () => {
          dispatch(clearError());
        },
      });
    }

    if (isProductDeleted) {
      toast("Product Deleted Successfully!", {
        type: "success",
      });

      dispatch(clearProductDeleted());

      dispatch(getAdminProducts(clocreProductId, filterStatus, currentPage));
    }
  }, [
    dispatch,
    error,
    productError,
    isProductDeleted,
    clocreProductId,
    filterStatus,
    currentPage,
  ]);

  // Drawer
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  // Navbar
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1000);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1000);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);

  const confirmProductDelete = (e) => {
    deleteHandler(e, productToDelete);
    setDeleteModalOpen(false);
    setProductToDelete(null);
  };
  const handleDeleteClick = (id) => {
    // console.log(id);
    setProductToDelete(id);
    setDeleteModalOpen(true);
  };

  const cancelProductDelete = () => {
    setDeleteModalOpen(false);
    setProductToDelete(null);
  };

  const downloadExcel = () => {
    const excelData = products.map((product, index) => ({
      "S.No": index + 1,
      "Product ID": product.clocreProductId,
      SKU:
        product.variants && product.variants.length > 0
          ? product.variants.map((v) => v.sku).join(" , ")
          : product.sku,

      "Product Name": product.name,

      Stock:
        product.variants && product.variants.length > 0
          ? product.variants.map((v) => v.stock).join(" , ")
          : product.stock,

      Status: product.status,

      "Created Date": new Date(product.createdAt).toLocaleDateString(),

      "Uploaded By": product.createdBy
        ? `${product.createdBy.name} (${product.createdBy.email})`
        : "N/A",
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);

    worksheet["!cols"] = [
      { wch: 10 },
      { wch: 18 },
      { wch: 30 },
      { wch: 60 },
      { wch: 12 },
      { wch: 18 },
      { wch: 18 },
      { wch: 40 },
    ];

    const range = XLSX.utils.decode_range(worksheet["!ref"]);

    for (let row = range.s.r; row <= range.e.r; row++) {
      for (let col = range.s.c; col <= range.e.c; col++) {
        const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });

        if (!worksheet[cellAddress]) continue;

        worksheet[cellAddress].s = {
          font: {
            bold: row === 0,
            color: { rgb: row === 0 ? "FFFFFF" : "000000" },
            sz: 12,
          },

          fill:
            row === 0
              ? {
                  fgColor: { rgb: "FFAD63" },
                }
              : undefined,

          alignment: {
            horizontal: "center",
            vertical: "center",
            wrapText: true,
          },

          border: {
            top: { style: "thin", color: { rgb: "D3D3D3" } },
            bottom: { style: "thin", color: { rgb: "D3D3D3" } },
            left: { style: "thin", color: { rgb: "D3D3D3" } },
            right: { style: "thin", color: { rgb: "D3D3D3" } },
          },
        };
      }
    }

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Products");

    const today = new Date();

    const formattedDate = `${today.getDate()}-${
      today.getMonth() + 1
    }-${today.getFullYear()}_${today.getHours()}-${today.getMinutes()}`;

    XLSX.writeFile(workbook, `GLOCRE_Products_${formattedDate}.xlsx`, {
      cellStyles: true,
    });
  };

  return (
    <>
      <MetaData title="Product List | GLOCRE" />
      <section className="prodlist-section">
        <div className="row container-fluid">
          <div className="col-lg-2">
            <Sidebar />
          </div>
          <div className="col-12 col-lg-10 col-md-12 pr-0">
            <div className="mobile-logo">
              <Link to="/">
                <img
                  src={require("../../images/procure-g-logo.png")}
                  alt="mobile-logo"
                />
              </Link>
            </div>
            <div className="breadcrumbWrapperr">
              {/* Breadcrumbs & Menu Icon Row (For Mobile) */}
              {isMobile ? (
                <div className="row mobile-topbar">
                  <div className="col-10">
                    <ul className="breadcrumb breadcrumb2 mb-0">
                      <li>
                        <Link to="/admin/dashboard" style={{ color: "#fff" }}>
                          Dashboard
                        </Link>
                      </li>
                      <li>Product List</li>
                    </ul>
                  </div>
                  <div className="col-2 p-0 d-flex justify-content-center align-items-center">
                    <button className="fab" onClick={toggleDrawer}>
                      <FontAwesomeIcon icon={faList} />
                    </button>
                  </div>
                </div>
              ) : (
                <div className="row dash-navbar-big-glc small-sticky-navbar">
                  <div className="col-lg-3 col-md-12">
                    <ul className="breadcrumb breadcrumb2 mb-0">
                      <li>
                        <Link to="/admin/dashboard">Dashboard</Link>
                      </li>
                      <li>Product List</li>
                    </ul>
                  </div>
                  <div className="col-lg-7 col-md-6 d-flex justify-content-end align-items-end">
                    <div className="dash-cont-glc">
                      <div className="row">
                        <div className="topnav">
                          <div className="search-container">
                            <form
                              className="d-flex"
                              onSubmit={(e) => e.preventDefault()}
                            >
                              <input
                                type="text"
                                placeholder="Search"
                                name="search"
                                value={clocreProductId}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  const cleanedValue = value.replace(
                                    /[^a-zA-Z0-9 ]/g,
                                    "",
                                  );
                                  setclocreProductId(cleanedValue);
                                }}
                              />
                              <button type="submit">
                                <FontAwesomeIcon icon={faSearch} />
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-1 col-md-2 d-flex justify-content-center align-items-end">
                    <Dropdown className="d-inline">
                      <Dropdown.Toggle
                        variant="default"
                        id="dropdown-basic"
                        className="custom-filter-toggle"
                      >
                        <FontAwesomeIcon icon={faFilter} />
                        <span className="ms-2">{filterLabel}</span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          onClick={() => handleFilterChange("approved")}
                        >
                          Approved
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => handleFilterChange("pending")}
                        >
                          Pending
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => handleFilterChange("rejected")}
                        >
                          Rejected
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => handleFilterChange("deactivated")}
                        >
                          Deactivated
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => handleFilterChange("")}>
                          All
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              )}
              {/* Search, Filter & Avatar Row (For Mobile) */}
              {isMobile && (
                <div className="row mobile-bottombar">
                  <div className="col-9 col-md-10 pr-0">
                    <div className="search-container">
                      <form
                        className="d-flex"
                        onSubmit={(e) => e.preventDefault()}
                      >
                        <input
                          type="text"
                          placeholder="Search"
                          name="search"
                          // value={clocreProductId}
                          onChange={(e) => {
                            const value = e.target.value;
                            const cleanedValue = value.replace(
                              /[^a-zA-Z0-9 ]/g,
                              "",
                            );
                            setclocreProductId(cleanedValue);
                          }}
                        />
                        <button type="submit">
                          <FontAwesomeIcon icon={faSearch} />
                        </button>
                      </form>
                    </div>
                  </div>
                  <div className="col-3 col-md-2 d-flex justify-content-center align-items-end">
                    <Dropdown className="d-inline">
                      <Dropdown.Toggle
                        variant="default text-white"
                        id="dropdown-basic"
                        className="text-dark dropdown1 icon-list-filter-procureg"
                        style={{
                          backgroundImage: "none",
                          border: "none",
                          boxShadow: "none",
                        }}
                      >
                        <FontAwesomeIcon icon={faFilter} />
                        <span className="ms-2">{filterLabel}</span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          onClick={() => handleFilterChange("approved")}
                        >
                          Approved
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => handleFilterChange("pending")}
                        >
                          Pending
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => handleFilterChange("rejected")}
                        >
                          Rejected
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => handleFilterChange("deactivated")}
                        >
                          Deactivated
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => handleFilterChange("")}>
                          All
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              )}
              {/* Drawer Component */}
              <Drawer
                open={isDrawerOpen}
                onClose={toggleDrawer}
                direction="right"
                className="drawer"
              >
                <div className="drawer-header">
                  ADMIN DASHBOARD
                  {/* <button className="drawer-close-btn" onClick={toggleDrawer}>&times;</button> */}
                </div>
                <div className="drawer-content">
                  <ul className="drawer-links">
                    <li>
                      <Link to="/admin/dashboard">
                        <FontAwesomeIcon icon={faDashboard} /> &nbsp;Dashboard
                      </Link>
                    </li>
                    <li>
                      <Link to="/admin/products">
                        <FontAwesomeIcon icon={faCartShopping} /> &nbsp;Product
                        List
                      </Link>
                    </li>
                    <li>
                      <Link to="/admin/products/create">
                        <FontAwesomeIcon icon={faShoppingBag} /> &nbsp;Create
                        Product
                      </Link>
                    </li>
                    <li>
                      <Link to="/admin/orders">
                        <FontAwesomeIcon icon={faSort} /> &nbsp;Order List
                      </Link>
                    </li>
                    <li>
                      <Link to="/admin/users">
                        <FontAwesomeIcon icon={faUserPlus} /> &nbsp;User List
                      </Link>
                    </li>
                    <li>
                      <Link to="/admin/reviews">
                        <FontAwesomeIcon icon={faPencil} /> &nbsp;Review List
                      </Link>
                    </li>
                    <li>
                      <Link to="/admin/edit-banner">
                        <FontAwesomeIcon icon={faPencil} className="me-2" />
                        Banner
                      </Link>
                    </li>
                    <li>
                      <Link to="/admin/awsimages">
                        <FontAwesomeIcon icon={faPencil} className="me-2" />
                        Images
                      </Link>
                    </li>
                  </ul>
                </div>
              </Drawer>
            </div>

            <div
              className="d-flex justify-content-between align-items-center flex-wrap"
              style={{ marginTop: "40px" }}
            >
              <h3 className="" style={{ color: "#ffad63", margin: 0 }}>
                PRODUCT LIST
              </h3>

              <button
                onClick={downloadExcel}
                className="btn"
                style={{
                  backgroundColor: "#2f4d2a",
                  color: "#fff",
                  border: "none",
                  padding: "7px 16px",
                  margin: "0px 18px",
                  borderRadius: "6px",
                  fontWeight: "500",
                }}
              >
                Download Excel
              </button>
            </div>

            <div className="mt-4">
              <div className="cartWrapper pr-3 mt-4">
                <div className="table-responsive" style={{ overflowX: "auto" }}>
                  <table className="table">
                    <thead>
                      <tr>
                        <th style={{ minWidth: "120px" }}>Product ID</th>
                        <th style={{ minWidth: "140px" }}>SKU</th>
                        <th style={{ minWidth: "200px" }}>NAME</th>
                        <th style={{ minWidth: "70px" }}>STOCK</th>
                        <th style={{ minWidth: "100px" }}>CREATED BY</th>
                        <th style={{ minWidth: "270px" }}>UPLOADED BY</th>
                        <th style={{ minWidth: "160px" }}>STATUS</th>
                        <th style={{ minWidth: "80px" }}>UPDATE</th>
                        <th style={{ minWidth: "80px" }}>DELETE</th>
                      </tr>
                    </thead>

                    <tbody>
                      {loading ? (
                        <Loader colSpan="6" />
                      ) : products.length === 0 ? (
                        <div className="text-center py-5">
                          <p style={{ color: "#8c8c8c", fontSize: "18px" }}>
                            You have no products. Please create one.
                          </p>
                          <Link to="/admin/products/create">
                            <button
                              className="btn mt-3"
                              style={{
                                backgroundColor: "#ffad63",
                                color: "#fff",
                              }}
                            >
                              Create Product
                            </button>
                          </Link>
                        </div>
                      ) : (
                        products.map((product) => (
                          <>
                            <tr
                              key={product._id}
                              style={{
                                opacity:
                                  product.status === "deactivated" ? 0.5 : 1,
                              }}
                            >
                              {/* Product ID */}
                              <td>
                                <span
                                  className="cursor"
                                  style={{ color: "#8c8c8c" }}
                                >
                                  {product.clocreProductId}
                                </span>
                              </td>

                              <td>
                                <div className="d-flex align-items-center">
                                  <span style={{ color: "#8c8c8c" }}>
                                    {product.variants &&
                                    product.variants.length > 0
                                      ? product.variants
                                          .map((v) => v.sku)
                                          .join(" & ")
                                      : product.sku}
                                  </span>
                                </div>
                              </td>

                              <td>
                                <div className="d-flex align-items-center">
                                  <span style={{ color: "#8c8c8c" }}>
                                    {product.name}
                                  </span>
                                </div>
                              </td>

                              {/* Stock */}
                              <td>
                                <span style={{ color: "#8c8c8c" }}>
                                  {product.variants &&
                                  product.variants.length > 0
                                    ? product.variants
                                        .map((v) => v.stock)
                                        .join(" & ")
                                    : product.stock > 0
                                      ? product.stock
                                      : "Out of Stock"}
                                </span>
                              </td>

                              <td>
                                <span className="text-g">
                                  {new Date(
                                    product.createdAt,
                                  ).toLocaleDateString()}
                                </span>
                              </td>

                              <td>
                                <span style={{ color: "#8c8c8c" }}>
                                  {product.createdBy ? (
                                    <>
                                      <span style={{ color: "#8c8c8c" }}>
                                        {[
                                          product.createdBy?.name,
                                          product.createdBy?.lastName,
                                        ]
                                          .filter(Boolean)
                                          .join(" ")}
                                      </span>

                                      <div
                                        style={{
                                          fontSize: "12px",
                                          color: "#8c8c8c",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {product.createdBy.email}
                                      </div>
                                    </>
                                  ) : (
                                    "N/A"
                                  )}
                                </span>
                              </td>

                              <td>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "4px",
                                  }}
                                >
                                  <span
                                    style={{
                                      padding: "5px 10px",
                                      borderRadius: "5px",
                                      color: "#fff",
                                      backgroundColor:
                                        product.status === "approved"
                                          ? "#52c41a"
                                          : product.status === "pending"
                                            ? "#faad14"
                                            : product.status === "rejected"
                                              ? "#ff4d4f"
                                              : product.status === "deactivated"
                                                ? "#8c8c8c"
                                                : "#ccc",
                                      fontSize: "13px",
                                      width: "fit-content",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {product.status}
                                  </span>

                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "500",
                                      lineHeight: "18px",
                                      color: "#8c8c8c",
                                    }}
                                  >
                                    {product.status === "approved" &&
                                      product.approvedBy?.name && (
                                        <>
                                          By{" "}
                                          <span style={{ color: "#2f4d2a" }}>
                                            <>
                                              <span
                                                style={{ color: "#2f4d2a" }}
                                              >
                                                {[
                                                  product.approvedBy?.name,
                                                  product.approvedBy?.lastName,
                                                ]
                                                  .filter(Boolean)
                                                  .join(" ")}
                                              </span>
                                              {product.approvedBy?.email && (
                                                <>
                                                  <br />
                                                  <span
                                                    style={{
                                                      color: "#8c8c8c",
                                                      fontSize: "11px",
                                                      wordBreak: "break-word",
                                                    }}
                                                  >
                                                    {product.approvedBy.email}
                                                  </span>
                                                </>
                                              )}
                                            </>
                                          </span>
                                        </>
                                      )}

                                    {product.status === "rejected" &&
                                      product.rejectedBy?.name && (
                                        <>
                                          By{" "}
                                          <span style={{ color: "#ff4d4f" }}>
                                            <>
                                              <span
                                                style={{ color: "#2f4d2a" }}
                                              >
                                                {[
                                                  product.rejectedBy?.name,
                                                  product.rejectedBy?.lastName,
                                                ]
                                                  .filter(Boolean)
                                                  .join(" ")}
                                              </span>
                                              {product.rejectedBy?.email && (
                                                <>
                                                  <br />
                                                  <span
                                                    style={{
                                                      color: "#8c8c8c",
                                                      fontSize: "11px",
                                                      wordBreak: "break-word",
                                                    }}
                                                  >
                                                    {product.rejectedBy.email}
                                                  </span>
                                                </>
                                              )}
                                            </>
                                          </span>
                                        </>
                                      )}

                                    {product.status === "deactivated" &&
                                      product.deactivatedBy?.name && (
                                        <>
                                          By{" "}
                                          <span style={{ color: "#ff4d4f" }}>
                                            <>
                                              <span
                                                style={{ color: "#2f4d2a" }}
                                              >
                                                {[
                                                  product.deactivatedBy?.name,
                                                  product.deactivatedBy
                                                    ?.lastName,
                                                ]
                                                  .filter(Boolean)
                                                  .join(" ")}
                                              </span>
                                              {product.deactivatedBy?.email && (
                                                <>
                                                  <br />
                                                  <span
                                                    style={{
                                                      color: "#8c8c8c",
                                                      fontSize: "11px",
                                                      wordBreak: "break-word",
                                                    }}
                                                  >
                                                    {
                                                      product.deactivatedBy
                                                        .email
                                                    }
                                                  </span>
                                                </>
                                              )}
                                            </>
                                          </span>
                                        </>
                                      )}
                                  </span>
                                </div>
                              </td>

                              <td>
                                {product.status === "deactivated" ? (
                                  <span
                                    className="btn btn-secondary"
                                    style={{
                                      backgroundColor: "#ffad63",
                                      cursor: "not-allowed",
                                      opacity: 0.6,
                                      outline: "none",
                                      border: "none",
                                    }}
                                    title="Cannot edit deactivated product"
                                  >
                                    <FontAwesomeIcon icon={faPencil} />
                                  </span>
                                ) : (
                                  <Link
                                    to={`/admin/products/${product._id}`}
                                    state={{ filterStatus, currentPage }}
                                  >
                                    <span
                                      className="cursor btn btn-primary"
                                      style={{
                                        backgroundColor: "#ffad63",
                                        outline: "none",
                                        border: "none",
                                      }}
                                    >
                                      <FontAwesomeIcon icon={faPencil} />
                                    </span>
                                  </Link>
                                )}
                              </td>

                              <td>
                                <Button
                                  style={{
                                    backgroundColor: "#2f4d2a",
                                    outline: "none",
                                    border: "none",
                                    color: "#fff",
                                  }}
                                  onClick={() => handleDeleteClick(product._id)}
                                  className="btn ms-2"
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </Button>
                              </td>

                              <Modal
                                open={deleteModalOpen}
                                onClose={cancelProductDelete}
                              >
                                <Box
                                  sx={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    bgcolor: "background.paper",
                                    p: 4,
                                    borderRadius: 2,
                                    width: 300,
                                    border: "none",
                                    outline: "none",
                                  }}
                                >
                                  <Typography
                                    variant="h6"
                                    mb={2}
                                    align="center"
                                    fontSize={17}
                                    color="#8c8c8c"
                                  >
                                    Are you sure want to delete this product?(It
                                    wont be recovered)
                                  </Typography>
                                  <Box
                                    display="flex"
                                    justifyContent="space-between"
                                  >
                                    <Button
                                      onClick={confirmProductDelete}
                                      className="left-but"
                                      sx={{
                                        margin: "3px",
                                      }}
                                    >
                                      Yes
                                    </Button>
                                    <Button
                                      onClick={cancelProductDelete}
                                      className="right-but"
                                      sx={{
                                        margin: "3px",
                                      }}
                                    >
                                      No
                                    </Button>
                                  </Box>
                                </Box>
                              </Modal>
                            </tr>
                          </>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <br />
              {filteredProductsCount > 0 &&
              filteredProductsCount > resPerPage ? (
                <div className="d-flex justify-content-center tab-slider">
                  <Pagination
                    activePage={currentPage}
                    onChange={setCurrentPageNo}
                    totalItemsCount={filteredProductsCount}
                    itemsCountPerPage={resPerPage}
                    nextPageText={"Next"}
                    firstPageText={"First"}
                    lastPageText={"Last"}
                    itemClass={"page-item"}
                    linkClass={"page-link"}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
